export default {
  getUserSetting: (state) => state.userSetting,
};
